import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { saveFile } from '../helpers/file-download';
import { BaseHttpService } from './base-http.service';
import { EventRequestModel, Permission, AcknowledgementPermission, EventRequestChangeStatusType, EventRequesAcknowledgeModel, EventRequesAcknowledgeListModel, RequestBuildingUnitView, CompanyBuildingUnitView, PaginationModel, PagedResult, EventRequestTotals, EventRequestAutocomplete, VenueMeetingItem, RequestCharge, InvoiceChargesTenants } from '../models';
import { InvoiceRequestsModel, InvoiceFile, ChargeTransactions, InvoiceTotal } from '@app/core';

@Injectable()
export class InvoiceService extends BaseHttpService<any> {

  constructor(private http: HttpClient) {
    super('invoices');
  }
 
  AddInvoiceRequest(formData: FormData):Observable<EventRequestModel> {
    return this.http
      .post(this.getApiURI() + '/invoices/AddCharges', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }
  UploadInvoice(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/invoices/SaveInvoice', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }
  getInvoiceRequests(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<InvoiceRequestsModel>> {
    return this.http
      .get(this.getApiURI() + '/invoices/GetInvoiceRequests' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  getInvoiceTotal(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<InvoiceTotal>> {
    return this.http
      .get(this.getApiURI() + '/invoices/GetInvoicesByTotal' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  approveInvoiceByTenant(requestId: number, PO: string): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/invoices/${requestId}/approve-invoice-tenant`, { PO: PO })
      .catch(this.handleError)
  }
  approveInvoiceByTSD(requestId: number): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/invoices/${requestId}/approve-invoice-TSD`, {})
      .catch(this.handleError)
  }
  rejectInvoiceByTenant(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-invoice-tenant`, { comments: comments })
      .catch(this.handleError)
  }
  rejectInvoiceByTSD(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-invoice-TSD`, { comments: comments })
      .catch(this.handleError)
  }
  getInvoiceFiles(): Observable<InvoiceFile[]> {
    return this.httpClient
      .get(this.uri + `/GetFiles`)
      .catch(this.handleError);
    }
  downloadFileByPath(path: string) {
      this.http.get(path, { observe: "response", responseType: "blob" }).subscribe(res => {
        const fileName = res.headers.get("x-filename");
        var blob = new Blob([res.body]);
        saveFile(res.body, fileName);
        return blob;
      });
    }
  getChargesList(model: { paginationModel: PaginationModel, pendingOnly: boolean, fromDate: string, toDate: string, requestStatusId: number, searchVal: string, requestId: number }): Observable<PagedResult<ChargeTransactions>> {
      return this.http
        .get(this.getApiURI() + '/invoices/GetMyCharges' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&fromDate=${model.fromDate}&toDate=${model.toDate}&requestStatusId=${model.requestStatusId}&searchVal=${model.searchVal}&requestId=${model.requestId}`)
        .catch(this.handleError)
    }

  getChargeListAll(model:
    {
      paginationModel: PaginationModel,
      pendingOnly: boolean,
      fromDate: string,
      toDate:
      string, requestStatusId:
      number, searchVal: string,
      requestId: number
    }): Observable<ChargeTransactions[]> {

    return this.http
      .get(this.getApiURI() + '/invoices/GetMyCharges'
        + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}`
        + `&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}`
        + `&pendingOnly=${model.pendingOnly}&fromDate=${model.fromDate}&toDate=${model.toDate}`
        + `&requestStatusId=${model.requestStatusId}`
        + `&searchVal=${model.searchVal}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }



    changeInvoicePaid(invoiceNo: string, paid: boolean): Observable<any> {
      return this.httpClient
        .put(this.getApiURI() + `/invoices/${invoiceNo}/change-invoice-paid`, { paid: paid })
        .catch(this.handleError)
    }
    getCoverPage(so: string): Observable<string> {
      return this.httpClient
        .put(this.getApiURI() + `/invoices/${so}/get-cover-page`, { })
        .catch(this.handleError)
    }
    getTenantsCharges(so: string): Observable<InvoiceChargesTenants> {
      return this.httpClient
        .get(this.getApiURI() + `/invoices/${so}/get-tenants-charges`, {})
        .catch(this.handleError)
    }
}



// WEBPACK FOOTER //
// ./src/app/core/data/invoice.service.ts